export function analyzeRecordChanges(
  previousState: Record<string, any>,
  currentState: Record<string, any>
): {
  newEntries: string[]
  entriesWithNewStates: string[]
  removedEntries: string[]
  entriesWithRemovedStates: string[]
} {
  const newEntries: string[] = []
  const entriesWithNewStates: string[] = []
  const removedEntries: string[] = []
  const entriesWithRemovedStates: string[] = []

  for (const id in currentState) {
    if (!Object.hasOwn(previousState, id)) {
      newEntries.push(id)
    } else if (currentState[id] && currentState[id].length > previousState[id].length) {
      entriesWithNewStates.push(id)
    } else if (currentState[id] && currentState[id].length < previousState[id].length) {
      entriesWithRemovedStates.push(id)
    }
  }

  for (const id in previousState) {
    if (!Object.hasOwn(currentState, id)) {
      removedEntries.push(id)
    }
  }

  return { newEntries, entriesWithNewStates, removedEntries, entriesWithRemovedStates }
}
